import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Profile } from 'app/models';
import * as tableHelpers from 'app/helpers/tableSelectionHelpers';
import { Subject, takeUntil } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-user-selection-dialog',
  standalone: false,
  templateUrl: './user-selection-dialog.component.html',
  styleUrls: ['./user-selection-dialog.component.scss']
})
export class UserSelectionDialogComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  private readonly onDestroy$ = new Subject<void>();

  title: string = '';
  users: Profile[] = [];
  primaryButtonText: string = '';
  secondaryButtonText: string = '';
  selection: SelectionModel<Profile> = new SelectionModel<Profile>(true, []);
  currentPageUsers: Profile[];
  usersDataSource: MatTableDataSource<Profile> = new MatTableDataSource<Profile>([]);
  noRecordsFound = false;

  displayedColumns = ['select', 'name', 'email'];
  message = 'No_Users_Found';


  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.title = data.title;
    this.users = data.users;
    this.primaryButtonText = data.primaryButtonText;
    this.secondaryButtonText = data.secondaryButtonText;
  }

  ngOnInit(): void {

    this.setupTable(this.users);

    this.usersDataSource
      .connect()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((users) => {
        this.currentPageUsers = users;
      });
  }


  isAllSelected = () => tableHelpers.isAllSelected(this.currentPageUsers, this.selection.selected);

  masterToggle = () => tableHelpers.masterToggle(this.currentPageUsers, this.selection);

  isPartiallySelected = () => tableHelpers.isPartiallySelected(this.currentPageUsers, this.selection.selected);

  setupTable(users: Profile[] = []): void {
    if (users.length === 0) {
      this.noRecordsFound = true;
      return;
    }
    this.noRecordsFound = false;
    this.usersDataSource.data = users;
    setTimeout(() => {
      this.usersDataSource.paginator = this.paginator;
      this.usersDataSource.sort = this.sort;
    },20)
    
  }

  monitorSearch(searchString: string) {
    if (searchString.trim().length >= Number(environment.minimumSearchLength)) {
      let filteredUsers = this.users.filter(
        (user) =>
          user['name'].toUpperCase().includes(searchString.toUpperCase()) ||
          user['email'].toUpperCase().includes(searchString.toUpperCase())
      );
      this.setupTable(filteredUsers);
      this.noRecordsFound = filteredUsers.length === 0;
    } else {
      this.setupTable(this.users);

    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
